import React from 'react';
import GraphViewer from './GraphViewer';

import gaussian from 'gaussian';


export default function DistributionSlider() {
    const config = {
      title: "Kurtosis Distribution",
      description: "Adjust kurtosis to see how tail thickness changes in a normal distribution.",
      sliders: [
        { key: "kurtosis", label: "Kurtosis", min: 1, max: 6, step: 0.1, default: 2 }
      ],
      generate: ({ kurtosis }) => {
        const dist = gaussian(0, 1);
        const xValues = Array.from({ length: 200 }, (_, i) => -4 + (i * 8) / 199);
        const points = xValues.map(x => {
          const z = x;
          const basePdf = dist.pdf(x);
          const tail = 1 + (kurtosis - 2) * Math.exp(-Math.pow(z, 2) / 2);
          const adjusted = basePdf * tail + 0.002 * Math.pow(Math.abs(z), kurtosis - 2);
          return { x, y: adjusted };
        });
  
        return {
          labels: points.map(p => p.x.toFixed(2)),
          datasets: [
            {
              label: `Kurtosis: ${kurtosis}`,
              data: points.map(p => p.y),
              borderColor: 'blue',
              fill: false,
              tension: 0.2,
              pointRadius: 0,
            }
          ]
        };
      }
    };
  
    return <GraphViewer config={config} />;
  }
  